import type { Schema_Applicant } from 'cpool-schemas';
import { useTranslation } from 'react-i18next';

const CLASS_TH = 'py-1.5 pr-2.5 text-10 text-left border-b-2 text-grey border-stroke';
const CLASS_TD = 'py-1.5 pr-2.5 text-left text-10 text-grey whitespace-nowrap';

type LoansApplicantInformationTableProps = {
    applicant: Schema_Applicant;
};

const LoansApplicantInformationTable: React.FC<LoansApplicantInformationTableProps> = ({ applicant }) => {
    const { t } = useTranslation();

    return (
        <div className="max-w-full px-4 overflow-x-auto bg-white mb-2.5">
            <table className="w-full table-auto">
                <thead>
                    <tr>
                        <th className={CLASS_TH}>{t('PERSONAL_DATA.LASTNAME')}</th>
                        <th className={CLASS_TH}>{t('PERSONAL_DATA.FIRSTNAME')}</th>
                        <th className={CLASS_TH}>{t('PERSONAL_DATA.SALUTATIONS')}</th>
                        <th className={CLASS_TH}>{t('PERSONAL_DATA.BIRTHDATE')}</th>
                        <th className={CLASS_TH}>{t('PERSONAL_DATA.BIRTHPLACE')}</th>
                        <th className={CLASS_TH}>{t('ADDRESS.RESIDENCE')}</th>
                        <th className={CLASS_TH}>{t('ADDRESS.STREET')}</th>
                        <th className={CLASS_TH}>{t('ADDRESS.ZIP_CODE_SHORT')}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className={CLASS_TD}>{applicant.personendaten.nachname}</td>
                        <td className={CLASS_TD}>{applicant.personendaten.vorname}</td>
                        <td className={CLASS_TD}>{applicant.personendaten.anrede}</td>
                        <td className={CLASS_TD}>{applicant.personendaten.geburtsdatum.toLocaleDateString()}</td>
                        <td className={CLASS_TD}>{applicant.personendaten.geburtsort}</td>
                        <td className={CLASS_TD}>{applicant.wohnsituation.anschrift?.ort || ''}</td>
                        <td className={CLASS_TD}>{applicant.wohnsituation.anschrift?.strasse || ''}</td>
                        <td className={CLASS_TD}>{applicant.wohnsituation.anschrift?.plz || ''}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default LoansApplicantInformationTable;
